import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { closeSlidingMenuLayer } from "../../actions/toggleSlidingMenu";

const useCloseSlidingPanel = () => {
  const dispatch = useDispatch();
  const onCloseSlidingPanel = useCallback(() => {
    dispatch(closeSlidingMenuLayer());
  }, [dispatch]);

  return onCloseSlidingPanel;
};

export default useCloseSlidingPanel;
